import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { AnimatePresence } from 'framer-motion';
import { useCardDetailStore } from '../stores/cardDetail';
import { CardDetail } from './CardDetail';

// The single mount point for the card lightbox. Mounted once in RouteLayout,
// so every opener — CardTile's secondary click, the ActionBar's Info verb,
// anything added later — works by writing to the store and nothing else.
//
// AnimatePresence lives here rather than inside CardDetail: that component
// unmounts the instant the store clears, so an AnimatePresence in there could
// never run its own exit.
//
// The host sits OUTSIDE RouteLayout's route-crossfade tree, which would
// otherwise unmount it on every navigation and cut the exit animation short.
// The trade is that a lightbox left open across a route change would survive
// into a screen that has moved on, so close it explicitly on pathname change.

export function CardDetailHost() {
  const card = useCardDetailStore((s) => s.card);
  const close = useCardDetailStore((s) => s.close);
  const { pathname } = useLocation();

  useEffect(() => {
    // Reads through getState so this fires only on real navigations, not
    // every time the inspected card changes.
    if (useCardDetailStore.getState().card !== null) close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <AnimatePresence>
      {card && <CardDetail key={card.instanceId ?? card.id} card={card} onClose={close} />}
    </AnimatePresence>
  );
}
